import { Component, EventEmitter, HostListener, Input, OnInit, Output, ViewChild, ViewChildren } from '@angular/core';
import { Config } from '../../config/config';
import { RestDataService } from '../../service/rest-data.service';
import { SharedDataService } from '../../service/shared-data.service';

@Component({
  selector: 'app-secondary-brand-form',
  templateUrl: './secondary-brand-form.component.html',
  styleUrls: ['./secondary-brand-form.component.scss']
})


export class SecondaryBrandFormComponent implements OnInit {
  addedBrand: any;
  i: number;
  insideAddedBrand: boolean = false;
  currentSelectedBrand: number;
  brandSuggestion: any;
  filteredNewBrandSuggestion: any =[];
  brandQuery: any;
  modelQuery: string ='';
  insideAddedModel: boolean = false;
  currentSelection = 0;
  filteredNewModelSuggestion: any =[];
  modelSuggestion: any;
  domainConfig:any;
  category:any;
  categories:any;

  @ViewChild('brandList', {static: false}) brandList;
  @ViewChild('modelList', {static: false}) modelList;
  @ViewChildren('brandInput') brandField;
  @ViewChildren('modelInput') modelField;
  allModels: any;


  @Input()
  set brandCategory(cat:any){
   this.category =cat;
  }

  @Input()
  set brandCategories(cats:any){
   this.categories =cats;
  }

  @Input()
  set index (input: number){
    this.i = input;
  }
  @Input()
  set sendAddedBrand (addedBrand: any) {
    this.addedBrand = addedBrand ? addedBrand : [];
  }
  @Input()
  set brandSuggestionList1 (brandSuggestionList: any) {
    this.brandSuggestion = brandSuggestionList ? brandSuggestionList : [];
  }
  @Input()
  set modelSuggestionList (modelSuggestionList: any) {
    this.modelSuggestion = modelSuggestionList ? modelSuggestionList : [];
  }
  @Input()
  set listOfAllModels (modelList: any) {
    this.allModels = modelList ? modelList : [];
  }
  @Input() storyEditMode : boolean;

  @Output() brandChanged: EventEmitter<number> = new EventEmitter();

  constructor(private restService: RestDataService,
    private config: Config,
    private sharedService: SharedDataService) { 
      this.domainConfig = this.sharedService.currentDomainConfiguration;
    }

  ngOnInit() {
    if(this.addedBrand['brand']){
      this.brandQuery = this.addedBrand['brand'];
    }
    if(this.addedBrand['model']){
      this.modelQuery = this.addedBrand['model'];
    }
    if(this.categories !=null && this.category!=null)
     this.fetchBrandForACategories();
   
  }
 
 updateBrand(){

 } 
 getBrandSearchChar() : String{
  if(this.brandQuery!=null && this.brandQuery.length>0){
     return "?searchChars="+this.brandQuery;
  }
  return "";
 } 

 fetchBrandForACategories(){
  let el = this.categories.filter(e => (e.categoryName == this.category));
  if(el && el.length>0)
  {
      this.restService.http_get(this.config.get('product').baseUrl + '/api/cms/story/brandproduct/' + el[0].id+this.getBrandSearchChar())
    .subscribe(
      data => {
        if(data)
        {

          this.brandSuggestion = [];
          for(const brand in data)
          {
            this.brandSuggestion.push(brand);
            let models = data[brand];
            let brandModels = [];
            for(const model in models)
            {
              this.allModels.push(model);
              brandModels.push(model);
            }
            this.modelSuggestion[brand]=brandModels; 
          }
          this.filteredNewBrandSuggestion = this.brandSuggestion; 
        }
      });
  }
 }

  focusInSuggest(model, index = 1) {
    if (model === 'brand'){
        this.insideAddedBrand = true;
        this.currentSelectedBrand = index;
      if (this.addedBrand['brand'] === null || this.addedBrand['brand'] === '') {
        this.filteredNewBrandSuggestion = this.brandSuggestion;
      }
    }
    if (model === 'model') {
      this.insideAddedModel = true;
      this.currentSelectedBrand = index;
      if (this.modelQuery === '') {
        if ((this.addedBrand['model'] !== null || this.addedBrand['model'] ==='') && this.addedBrand['brand'] !== '') {
          this.filteredNewModelSuggestion = this.modelSuggestion[this.addedBrand['brand']];
        } else {
          this.filteredNewModelSuggestion = this.allModels;
        }
      }
    }
  }
  
  setBranModel(){
    
  }
   
  filterAutoCompleteUp(event, model) {
    if (event.keyCode !== 9 && event.keyCode !== 27 && event.key !== 'Enter' && event.key !== 'ArrowDown' && event.key !== 'ArrowUp') {
      if (model === 'brand') {
        if (this.insideAddedBrand) {
          if((this.categories !=null && this.categories.length > 0) && (this.category!=null && this.category.length > 0)) {
            this.fetchBrandForACategories();
          }
          
          else
          {
          if (this.brandQuery.length > 0) {
            this.filteredNewBrandSuggestion = this.brandSuggestion.filter(function (el) {
              return el.toLowerCase().indexOf(this.brandQuery.toLowerCase()) > -1;
            }.bind(this));
          } else {
            this.addedBrand['brand'] = '';
            this.addedBrand['model'] = '';
            this.filteredNewBrandSuggestion = this.brandSuggestion;
          }
          }  
        } else {
          this.insideAddedBrand = true;
          this.filteredNewBrandSuggestion = [];
        }

      }
      else if (model === 'model') {
       
        if (this.insideAddedModel) {
          if (this.addedBrand['brand'] !== null && this.addedBrand['brand'].trim() !== '') {
            if (this.modelQuery.length > 0) {
              this.filteredNewModelSuggestion = this.modelSuggestion[this.addedBrand['brand']].filter(function (el) {
                return el.toLowerCase().indexOf(this.modelQuery.toLowerCase()) > -1;
              }.bind(this));
            } else {
              this.addedBrand['model'] = '';
              this.filteredNewModelSuggestion = this.modelSuggestion[this.addedBrand['brand']];
            }
          } else {
            if (this.modelQuery.length > 0) {
              this.filteredNewBrandSuggestion = this.allModels.filter(function (el) {
                return el.toLowerCase().indexOf(this.modelQuery.toLowerCase()) > -1;
              }.bind(this));
            } else {
              this.addedBrand['model'] = '';
              this.filteredNewBrandSuggestion = this.allModels;
            }
          }
        } else {
          this.insideAddedModel = true;
          this.filteredNewModelSuggestion = [];
        }
      }

    }
    // this.currentSelection = 0;
    return true;
  }

  filterAutoCompleteDown(event, model) {
    
   
    if (event.key === 'Enter') {
      if (model === 'brand') {
        this.insideAddedBrand = false;
        this.selectAutoComplete(model, this.filteredNewBrandSuggestion[this.currentSelection]);
      }
      if (model === 'model') {
        this.insideAddedModel = false;
        this.selectAutoComplete(model, this.filteredNewModelSuggestion[this.currentSelection]);
      }
    }
    else if (event.keyCode === 40) {
      event.preventDefault();
      if (model === 'brand') {
        if (this.currentSelection < (this.filteredNewBrandSuggestion.length - 1)) {
          this.currentSelection += 1;
          this.brandList.nativeElement.scrollBy(0, 23);
        }
      }
      if (model === 'model') {
        if (this.currentSelection < (this.filteredNewModelSuggestion.length - 1)) {
          this.currentSelection += 1;
          this.modelList.nativeElement.scrollBy(0, 23);
        }
      }
      event.stopPropagation();
    }
    else if (event.keyCode === 27) {
      event.preventDefault();
      this.insideAddedBrand = false;
      this.insideAddedModel = false;
      event.stopPropagation();
    }
    else if (event.keyCode === 38) {
      event.preventDefault();
      if (this.currentSelection > 0) {
        this.currentSelection -= 1;
        if (model === 'brand') {
          this.brandList.nativeElement.scrollBy(0, -23);
        }
        if (model === 'model') {
          this.modelList.nativeElement.scrollBy(0, -23);
        }
      }
      event.stopPropagation();
    }
    else if (event.keyCode === 8) {
      if (model === 'brand') {
        this.brandSuggestion.push(this.addedBrand["brand"]);
        this.addedBrand["brand"]="";
      }
    }

    else {
      this.currentSelection = 0;
    }
    return true;
  }

  selectAutoComplete(model, item) {
    if (model === 'brand') {
      this.brandQuery = item;
      this.addedBrand['brand'] = item;
      if (
        !(this.modelSuggestion.hasOwnProperty(item))
        || (this.modelSuggestion[item].length < 1)
        || (this.modelSuggestion[item].indexOf(this.addedBrand['model']) < 0)) {
        this.addedBrand['model'] = '';
        this.modelQuery = '';
      }
      this.filteredNewBrandSuggestion = [];
      this.insideAddedBrand = false;
      if(this.domainConfig['config'] && this.domainConfig['config']['story'] && 
      this.domainConfig['config']['story']['isAutoDomain'])
      this.loadModels(this.brandQuery);
    }
    else if (model === 'model') {
      this.modelQuery = item;
      this.addedBrand['model'] = item;
      if (this.addedBrand['brand'] === null || this.addedBrand['brand'] === '') {
        for (const brand in this.modelSuggestion) {
          if (brand && this.modelSuggestion[brand].indexOf(item) > -1) {
            this.addedBrand['brand'] = brand;
            this.brandQuery = brand;
            break;
          }
        }
      }
      this.filteredNewModelSuggestion = [];
    }
    this.brandChanged.emit(this.addedBrand)
  }

  @HostListener('document:click', ['$event'])
  handleClick(event) {
    const clickedComponent = event.target;

    if (this.brandField['_results'][0] && clickedComponent === this.brandField['_results'][0].nativeElement) {
      this.insideAddedBrand = true;
      if (this.brandQuery === '') {
        if(this.categories !=null && this.category!=null)
        this.fetchBrandForACategories();
        else
        this.filteredNewBrandSuggestion = this.brandSuggestion;
      }
      this.insideAddedModel = false;
      this.filteredNewModelSuggestion = [];
    }
    else if (this.modelField['_results'][0] && clickedComponent === this.modelField['_results'][0].nativeElement) {
      this.insideAddedModel = true;
      if (this.modelQuery === '') {
        if (this.addedBrand['brand'] !== null && (this.addedBrand['brand']) !== '') {
          this.filteredNewModelSuggestion = this.modelSuggestion[(this.addedBrand['brand'])];
        } else {
          this.filteredNewModelSuggestion = this.allModels;
        }
      }
      this.insideAddedBrand = false;
      this.filteredNewBrandSuggestion = [];
    }
    else {
      this.insideAddedBrand = false;
      this.insideAddedModel = false;
      this.filteredNewBrandSuggestion = [];
      this.filteredNewModelSuggestion = [];
    }
  }

  /**
   * load Models of a Brand 
   * @param brand 
   */
   private loadModels(brand:String){
      this.restService.http_get(this.config.get('product').utilUrl + '/api/cms/auto/'+brand+"/Products")
      .subscribe(
        data => {
          this.modelSuggestion[(this.addedBrand['brand'])]=data;
       },
        err => {
          // console.log(err);
        }
      );
     
  }

}
